<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { bulkUpdate } from './app_settings_helper';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	//Stores
	import { devices } from 'src/stores/lists/devices';
	//Design system components
	import { Toggle } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';
	import type { InputClickEvent } from '../../../types/InputClickEvent';

	export let device: Device;
	export let nameType: 'device' | 'channel' = 'device';
	export let info: string = '';

	const id = device.id;
	let checked = $devices[id].name_sync || false;
	let waitForResponse = false;

	const save = async (e: InputClickEvent) => {
		waitForResponse = true;
		checked = e.target.checked;
		const name_sync = checked;
		const res = await bulkUpdate(id, { name_sync });
		let toastTexts = {};
		if (res.isok) {
			toastTexts = {
				success: name_sync
					? $format('sync_name_enabled_scc_toast', {
							default: 'Name sync is enabled!',
						})
					: $format('sync_name_disabled_scc_toast', {
							default: 'Name sync is disabled!',
						}),
			};
		} else {
			// Revert to prev value when request fails
			checked = !checked;
		}

		onSettingsResponse(res, device, toastTexts);
		waitForResponse = false;
	};
</script>

<!-- 'sync name' will toggle the option that update device name in the interface data
	and the setting data. Which means if the device has only one channel 
	and only device name option the sync name toggle will be in that collapsable card.
	If device has multiple channels and has channel and device name 
	the toggle option will be in channel name collapse card,
	because channel name update the name of the interface data of the device 
	and local settings of the channel. On the other hand the device name option 
	update device name by default in the settings -->

<Toggle size="m" disabled={waitForResponse} bind:checked on:click={save} id="toggle-1hh77ki" {info}>
	{nameType === 'device'
		? $format('sync_device_name', {
				default: 'Sync device name',
			})
		: $format('sync_channel_name', {
				default: 'Sync channel name',
			})}
</Toggle>
